import React, { createContext, useState, useContext, ReactNode } from "react";

interface Project {
  annotations: number;
  createdDate: string; // ISO 8601 date format
  customerId: string;
  description: string;
  domainTypeId: string;
  id: string; // Assuming this is a UUID
  imageUrl: string;
  images: number;
  labels: number;
  liked: boolean;
  models: number;
  name: string;
  taskTypeId: string;
  thubmImageUrl: string; // Assuming this is a typo, should be "thumbImageUrl"
}

const initialState: Project = {
  annotations: 0,
  createdDate: "", // You could also set it to a default date, like "2024-11-28T00:00:00"
  customerId: "",
  description: "",
  domainTypeId: "",
  id: "", // Empty string for now, can be set later (e.g., UUID generation)
  imageUrl: "",
  images: 0,
  labels: 0,
  liked: false,
  models: 0,
  name: "",
  taskTypeId: "",
  thubmImageUrl: "", // Assuming it's still "thubmImageUrl", correct if needed
};

// Define the shape of the context data
interface ProjectsContextType {
  projectDetails: Project;
  setProjectDetails: React.Dispatch<React.SetStateAction<Project>>;
}

// Create the context with a default value
const ProjectsContext = createContext<ProjectsContextType | undefined>(
  undefined
);

// Define the type for the provider's props
interface ProjectsProviderProps {
  children: ReactNode;
}

// Create the provider component
export const ProjectsProvider: React.FC<ProjectsProviderProps> = ({
  children,
}) => {
  const [projectDetails, setProjectDetails] = useState<Project>(initialState);
  // Context value that is passed to consumers
  const value = {
    projectDetails,
    setProjectDetails,
  };

  return (
    <ProjectsContext.Provider value={value}>
      {children}
    </ProjectsContext.Provider>
  );
};

// Create a custom hook to use the Common
export const useProjects = (): ProjectsContextType => {
  const context = useContext(ProjectsContext);
  if (context === undefined) {
    throw new Error("useProjects must be used within a useProjectsProvider");
  }
  return context;
};
